import React from 'react';
import classnames from 'classnames';
import License from '../../../License';
import { isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import DeviationAttributeCSV from '../_partials/DeviationAttributeCSV';
import s from './Tier.scss';
const Tier = ({ deviation, deviation: { author, publishedTime, license }, className, contentClassName })=>{
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, isExtendedLoaded && /*#__PURE__*/ React.createElement("div", {
        className: s['misc']
    }, /*#__PURE__*/ React.createElement(DeviationAttributeCSV, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['license']
    }, /*#__PURE__*/ React.createElement(License, {
        license: license,
        author: author,
        publishedTime: publishedTime,
        showSymbol: false
    }))));
};
Tier.displayName = 'Tier';
export default Tier;
